module.exports = __webpack_public_path__ + "static/media/congrats.35f7bbda.gif";